package com.projectas.app.style

import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.style.selectors.selection
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.ms

val LogoStyle = CssStyle {
    base {
        Modifier
            .transform { rotate(0.deg) }
            .transition(
                Transition.of(
                    property = "transform",
                    duration = 200.ms
                )
            )
    }
    hover {
        Modifier.transform { rotate((-10).deg) }
    }
}

val StoreImageStyle = CssStyle {
    base {
        Modifier
            .transform { scale(sx = 1, sy = 1) }
            .transition(
                Transition.of(
                    property = "transform",
                    duration = 200.ms
                )
            )
    }
    hover {
        Modifier.transform { scale(sx = 1.1, sy = 1.1) }
    }
    selection {
        Modifier
            .backgroundColor(Colors.White)
            .color(Colors.Black)
    }
}